import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import LeversSidebarPicker from 'Views/Page/Content/Templates/roadmapExplorerPageTemplate/levers/picker';
import { RoadmapExplorerLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(RoadmapExplorerLayout, {
  condensed: true,
  fullHeight: true,
  customButtons: true,
  fullWidth: true,
  showSidebar: true,
  SidebarComponent: LeversSidebarPicker,
  renderLeftNav: false,
});

export const RoadmapExplorerPageTemplate = ({ resource }) => {
  const { loadPageContentLink, isPageContentLoading } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      layout={layout}
      LayoutProps={{ navigateToLink: loadPageContentLink, loading: isPageContentLoading }}
      resource={resource}
    />
  );
};

RoadmapExplorerPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
